import * as Styled from './field-error.styles';

const FieldError = ({ meta }) => {
    return <>{meta.touched && meta.error && <Styled.Error>{meta.error}</Styled.Error>}</>;
};

export default FieldError;
